import { render, staticRenderFns } from "./InfoHeadMenu.vue?vue&type=template&id=1fcf00c8"
import script from "./InfoHeadMenu.vue?vue&type=script&lang=ts"
export * from "./InfoHeadMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports